<template>
  <div
    :id="'chapter_' + chapter.chapterNumber"
    class="chapter"
    :style="{ display: visible ? 'block' : 'none' }"
  >
    <Pages
      v-for="({ pageNumber, content }, index) of pages"
      :key="index"
      :page-number="pageNumber"
      :content="content"
      :visible="currentPage === pageNumber"
    ></Pages>
  </div>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import BookService from '@/services/book'
import Pages from './Pages'

export default {
  name: 'ChapterContent',
  components: {
    Pages,
  },
  data() {
    return {
      selectedtext: '',
      htmlContent: '',
      pages: [],
    }
  },
  props: {
    resource: {
      type: String,
      default: '',
    },
    chapter: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      bookReadConf: (state) => state.bookReading.bookReadConf,
      currentPage: (state) => state.bookReading.currentPage,
    }),
  },
  async mounted() {
    const url = `${process.env.VUE_APP_BOOK_DATA_URL}${this.resource}/c_${this.$utils.pad(
      this.chapter.chapterNumber,
      2
    )}.html`
    const response = await BookService.getChapterContentHTML(url).catch((e) => console.error(e))
    const htmlContent = await response.text()
    const chapterContent = document.createElement('div')
    chapterContent.innerHTML = htmlContent
    this.pages = Array.from(chapterContent.querySelectorAll('.bookpage')).map((el) => ({
      content: el.innerHTML,
      pageNumber: parseInt(el.getAttribute('id').replace('bookpage_', ''), 10),
    }))
    this.increasePagesLoaded()
  },
    methods: {
        ...mapActions('bookReading', ['increasePagesLoaded']),
    },
}
</script>
